import {useState, useEffect} from 'react'
import {getDepartment} from '../services'
import {fetchData} from '../util/functions'
import {mapDataSelect} from '../../../util/functions'

const useDepartmentList = () => {
  const [departmentList, setDepartmentList] = useState([])

  const getDepartmentList = async () => {
    const response = (await fetchData({fetchFunction: getDepartment})) || []
    setDepartmentList(response)
  }

  useEffect(() => {
    getDepartmentList()
  }, [])

  const mappedSelectDepartmentList = mapDataSelect(departmentList)
  return {departmentList, mappedSelectDepartmentList}
}

export default useDepartmentList
